import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useLocation } from 'react-router-dom';
import { AccordionFullTable, CustomDelete } from 'components';
import { ACTION_TYPE_DELETE_LIBRARY_FOLDER, targetsTabTableInfo } from './constants';
import { onModelFolderEnum, sortListByKey, useModal } from 'utils';
import { libraryActions } from 'store';
import { AddFolder } from './addFolder';
import { TargetsDetails } from './targetsDetails';

export const TargetsTab = () => {
    const { libraryFolders } = useSelector((state) => ({
        libraryFolders: state.library.libraryFolders,
    }));
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const info = location?.state;
    const { open } = useModal();

    const renderParams = () => {
        const pushInfo = {
            ...info,
            onModel: onModelFolderEnum.TARGET,
        };
        pushInfo.skip = info?.skip ? info?.skip : 0;
        pushInfo.limit = 50;

        delete pushInfo.page;
        delete pushInfo.activeTab;
        delete pushInfo.tabType;
        return pushInfo;
    };

    useEffect(() => {
        getFolders();
    }, [info]);

    const getFolders = (load) => {
        dispatch(libraryActions.getLibraryFolders(renderParams(), load));
    };

    const handleAction = (item, name) => {
        if (name === 'edit') {
            open(<AddFolder requestParams={renderParams()} onModel={onModelFolderEnum.TARGET} info={item} />);
        }

        if (name === 'delete') {
            open(
                <CustomDelete
                    text="Are you sure you want to delete this folder? All targets inside it will be deleted. This action cannot be undone."
                    info="Delete Folder"
                    handleDel={() => dispatch(libraryActions.deleteLibraryFolder(item?.id, renderParams()))}
                    actionType={ACTION_TYPE_DELETE_LIBRARY_FOLDER}
                    innerText={'Delete'}
                />
            );
        }
    };
    return (
        <div className="library-targets-tab-wrapper">
            <AccordionFullTable
                classNameWrapper="library-targets-tab-accordion-wrapper"
                renderAccordionDetails={(item, isExpanded) => (
                    <TargetsDetails currentFolder={item} requestFoldersParams={renderParams()} isExpanded={isExpanded} />
                )}
                tableInfo={targetsTabTableInfo({ handleAction })}
                list={sortListByKey(libraryFolders?.data, 'name', info)}
                listCount={libraryFolders?.count}
                margin={'0'}
            />
        </div>
    );
};
